import React from 'react';

// Render footer
const Footer = () => {
  return (
    <footer class="w-100 mt-auto bg-secondary p-4">
      <div class="container text-center mb-5">
      <a href="https://github.com/TaylorRockwell">Github | </a>
      <a href="mailto:info@taylorrockwell.com">Email | </a>
    <a href="www.linkedin.com/in/taylor-rockwell-anderson-568531231">LinkedIn</a>
    
      </div>
    </footer>
  );
};

export default Footer;
